// @flow

export const DEFAULT_EXCHANGE_RATE = 1

export const DEFAULT_CURRENCY = 'RUB'
